export default class Recording {
  constructor (recording) {
    this.id = recording.id
    this.name = recording.name
    this.date = recording.date
    this.UserId = recording.UserId
    this.recordingUrl = recording.recordingUrl
  }
}
